import { Component } from '@angular/core';
import { ApiService } from '../../api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admin-order',
  templateUrl: './admin-order.component.html',
  styleUrls: ['./admin-order.component.scss'],
})
export class AdminOrderComponent {
  items = [
    {
      label: 'Mon client',
    },
    /*{
          label: 'Articles'
      },*/
    {
      label: 'Ma commande',
      disabled: true,
    },
  ];

  customers: any;
  customer: any;

  tabIndex = 0;
  stepIndex = 0;

  hideTexts = [
    [
      'TXT00003',
      'TXT00005',
      'TXT00007',
      'TXT00008',
      'TXT00009',
      'TXT00014',
      'TXT00016',
      'TXT00017',
      'TXT00020',
      'TXT00030',
      'TXT00031',
      'TXT00032',
      'TXT00033',
      'TXT00034',
      'TXT00044',
      'TXT00045',
      'TXT00046',
      'TXT00048',
      'TXT00049',
      'TXT00050',
      'TXT00051',
      'TXT00052',
      'TXT00053',
      'TXT00054',
      'TXT00055',
      'TXT00056',
      'TXT00057',
      'TXT00060',
      'TXT00061',
      'TXT00062',
      'TXT00080',
    ],
    [
      'TXT00001',
      'TXT00002',
      'TXT00011',
      'TXT00035',
      'TXT00036',
      'TXT00037',
      'TXT00038',
      'TXT00041',
    ],
  ];

  texts: any;

  savedOrders: any;

  constructor(public api: ApiService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.api.adminUser.subscribe((user: any) => {
      if (user && user.ebp_id) {
        //console.log(user);
        this.api
          .post('function=getNg2Customers', { ColleagueId: user.ebp_id })
          .then((res2: any) => {
            this.customers = res2;
          });
      }
    });

    if (this.route.snapshot.params['tabIndex']) {
      this.tabIndex = this.route.snapshot.params['tabIndex'];
    }
    
  }

  private isEditOrder(order: any): boolean {
    return order && (order.edit === true || order.edit === 'true' || order.edit === 1 || order.edit === '1');
  }

  /** Champs d'en-tête à reprendre du JSON devis (hors totaux recalculés par totalOrder). */
  private applyQuoteHeader(order: any) {
    const keys = [
      'createBy',
      'ref',
      'DocumentNumber',
      'xx_Code_Festival',
      'dotation',
      'notes',
      'ThirdOrderNumber',
      'DiscountRate',
      'freeShipping',
      'deliveryAddress',
      'addressChanged',
      'manualOrder',
      'offers',
    ];

    for (const key of keys) {
      if (order[key] !== undefined) {
        this.api.order[key] = order[key];
      }
    }

    this.api.order.edit = true;

    // Modif devis : défaut toujours "Commande" (le radio reste dispo pour repasser en Devis)
    this.api.order.devis = false;

    if (order.payment) {
      this.api.order.payment = Object.assign({}, order.payment);
    }

    if (order.DeliveryDate) {
      this.api.order.DeliveryDate = new Date(order.DeliveryDate);
    }

    if (order.createBy == null || order.createBy == 'undefined') {
      this.api.order.createBy = 'brg';
    }
  }

  chargeOrder(order) {
    this.customer = this.customers.find((item) => item.Id == order.customer.Id);
    if (!this.customer) {
      if (this.isEditOrder(order)) {
        this.api.error(
          'Client introuvable dans votre portefeuille (' +
            (order.customer && order.customer.Id ? order.customer.Id : '?') +
            '). Impossible de modifier ce devis.'
        );
      } else {
        this.api.error('Client introuvable dans votre portefeuille.');
      }
      return;
    }

    setTimeout(() => {
      if (this.isEditOrder(order)) {
        this.applyQuoteHeader(order);
      }
      this.api.order.notes = order.notes != null ? order.notes : this.api.order.notes;
      this.api.order.fromPro = true;
      this.api.user = this.api.order.customer = order.customer;
      this.api.totalOrder();
      this.tabIndex = 1;
    }, 1000);
  }

  loading = false;

  loginInit() {
    this.loading = true;
    this.api.totalOrder();
    this.showCustomerAlert(this.api.user.Id, 'onOrder');
    this.items[1].disabled = false;
  }

  allDotation(){
    let dotationText = this.api.texts.find((item) => item.Id == 'TXT00013');
    for(let prod of this.api.order.prods){
      setTimeout(() => {
        prod.lineText = dotationText;
        this.addTextLine(prod);
      }, 150);
    }
  }

  changeIndex(e) {
    this.stepIndex = e;
    if (this.api.adminUser.value && this.api.texts) {
      this.texts = this.api.texts.filter((item) => {
        if (item.Id == 'TXT00018' || item.Id == 'TXT00013')
          item.discountRateSupp = 100;
        if (item.Id == 'TXT00041') item.discountRateSupp = 30;
        return (
          this.hideTexts[parseInt(this.api.adminUser.value.export)].indexOf(
            item.Id
          ) === -1 && !item.discountRateSupp
        );
      });
      this.texts.unshift({ Id: 'TXT', Caption: '--- INFORMATION PREPA ---' });
      this.texts.unshift({ Id: 'TXT00080', Caption: '--- INFORMATION CLIENT ---' });
      if (this.api.adminUser.value.export == '1') {
        this.api.order.freeShipping = true;
      }
    }
  }

  addText(line) {
    line.type = 'text';
    line.id = new Date().getTime() * 2;
    this.api.order.prods.push(line);
    this.api.totalOrder();
  }

  addTextLine(row) {
    if (row.lineText && row.lineText.Id == 'sample') {
      row.sample = true;
      return false;
    }
    row.sample = false;
    let find = this.api.order.prods.find((item) => item.Id == row.lineText.Id);
    if (find != undefined) {
      row.id = find.id + 1;
    } else {
      let line = Object.assign({}, row.lineText);
      line.type = 'text';
      line.id = new Date().getTime();
      row.id = line.id + 1;
      this.api.order.prods.push(line);
    }
    row.discountRateSupp = row.lineText.discountRateSupp;
    this.api.totalOrder();
    return false;
  }

  customerAlert = {
    display: false,
    alerts: [],
  };
  
  showCustomerAlert(id, type) {
    this.api
      .post('SPDO_krolServer=select', {
        database: 'customer_alert',
        where: "CustomerId = '" + id + "' AND " + type + ' = 1 AND state = 1',
      })
      .then((res: any) => {
        if (res.data && res.data.length > 0) {
          this.customerAlert.alerts = res.data;
          this.customerAlert.display = true;
        }
        this.loading = false;
      });
  }

  disableAlert(a) {
    this.api
      .post('SPDO_krolServer=update', {
        database: 'customer_alert',
        data: { state: 0 },
        where: { id_customer_alert: a.id_customer_alert },
      })
      .then((res: any) => {});
  }

  displayModifyAlert = false;
  selectedAlert: any;
  modifyAlert() {
    this.api
      .post('SPDO_krolServer=update', {
        database: 'customer_alert',
        data: this.selectedAlert,
        where: { id_customer_alert: this.selectedAlert.id_customer_alert },
      })
      .then((res: any) => {});
  }
}
